import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { selectErrors, selectLoading } from '~/store/app';
import { requestProviderCategoryList, selectProviderCategoryList } from '~/store/provider';

export const useProviderCategoryList = () => {
  const dispatch = useDispatch();

  const categoryList = useSelector(selectProviderCategoryList);
  const isCategoryListLoading = useSelector(selectLoading(REQUEST_ACTIONS.PROVIDER_CATEGORY_LIST));
  const categoryListError = useSelector(selectErrors(REQUEST_ACTIONS.PROVIDER_CATEGORY_LIST));

  const getCategoryList = bindActionCreators(requestProviderCategoryList, dispatch);

  useEffect(() => {
    getCategoryList();
  }, []);

  return { categoryList, categoryListError, isCategoryListLoading };
};
